var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OuttripList',{attrs:{"outtrips":_vm.outtrips},on:{"lastShow":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }